// extracted by mini-css-extract-plugin
export var ignore = "_6q-1";
export var mapping = "_6q-0";
export var range = "_6q-4";
export var savings = "_6q-3";
export var settings = "_6q-2";